import { render, staticRenderFns } from "./Msg.vue?vue&type=template&id=1b4ef491&scoped=true"
import script from "./Msg.vue?vue&type=script&lang=js"
export * from "./Msg.vue?vue&type=script&lang=js"
import style0 from "./Msg.vue?vue&type=style&index=0&id=1b4ef491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ef491",
  null
  
)

export default component.exports